import {apiRequest} from './client';

export const ACCOUNT_DELETION_PENDING_MESSAGE = 'We\'ve received your request. Our team checks that nothing on your account is still being charged, then deletes it within 5 business days. We\'ll email you when it\'s done.';

export interface HeldAccountDeletion {
    id: string;
    email: string;
    requested_at: string;
    inventory: {
        subscriptions: Array<{id: string; processor: string; status: string; paykickstart_subscription_id: string | null; paykickstart_invoice_id?: string | null; paykickstart_transaction_id?: string | null}>;
        themes: Array<{id: string; status: string; paykickstart_subscription_id: string | null; paykickstart_invoice_id?: string | null; paykickstart_transaction_id?: string | null}>;
        stripe: Array<{tenant_id: string; stripe_account_id: string; onboarding_state: string; livemode: boolean}>;
    };
}

export const accountDeletionApi = {
    request(password?: string) {
        return apiRequest<{status?: string; state?: string} | undefined>('/auth/delete-account', {
            method: 'POST', body: JSON.stringify(password === undefined ? {} : {password})
        });
    },
    list() {
        return apiRequest<HeldAccountDeletion[]>('/superadmin/account-deletions');
    },
    cancel(jobId: string) {
        return apiRequest('/superadmin/account-deletions/' + encodeURIComponent(jobId) + '/cancel', {
            method: 'POST', body: '{}'
        });
    },
    release(jobId: string) {
        return apiRequest('/superadmin/account-deletions/' + encodeURIComponent(jobId) + '/release', {
            method: 'POST', body: '{}'
        });
    }
};
